<app-modal
  [title]="'Detalles del objetivo'"
  [loading]="loading"
>
  @if (objetivo; as actual) {
    <div class="mb-5 space-y-4">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
        <app-read-only-field label="Período" [value]="actual.periodo ? (actual.periodo.fecha_inicio | date:'dd/MM/yyyy') + ' al ' + (actual.periodo.fecha_fin | date:'dd/MM/yyyy') : 'No disponible'" />
        <app-read-only-field label="Alcance" [value]="actual.establecimiento?.nombre || (actual.cli_establecimiento_id ? 'Establecimiento no disponible' : 'Todos los establecimientos del cliente')" />
      </div>
      @if (actual.seguimiento; as seguimiento) {
        <app-badge [color]="estadosSeguimiento[seguimiento.estado].color">{{ estadosSeguimiento[seguimiento.estado].label }}</app-badge>
        @if (seguimiento.motivo) {
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ seguimiento.motivo }}</p>
        }
        @if (seguimiento.objetivos_coincidentes.length) {
          <p class="text-sm text-warning-700 dark:text-orange-400">Los resultados pueden llegar a compartirse con otros objetivos con el mismo rango de fecha del periodo</p>
        }
        @let avance = avanceVisual(actual);
        @if (avance.tipo === 'meta') {
          <div class="rounded-2xl border border-gray-200 p-4 dark:border-gray-800">
            <div class="flex flex-wrap items-baseline justify-between gap-2">
              <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Avance de preñeces</p>
              <p class="text-sm text-gray-500 dark:text-gray-400">{{ avance.conteo }} — {{ avance.porcentaje }} %</p>
            </div>
            <app-progress-bar
              class="mt-2 block"
              [value]="avance.porcentaje"
              [color]="avance.color"
              [ariaLabel]="'Avance de preñeces: ' + avance.porcentaje + ' por ciento'"
            />
            <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">{{ avance.detalle }}</p>
          </div>
        }
        <div class="grid grid-cols-2 gap-3 md:grid-cols-3">
          @if (actual.objetivo !== 'T') {
            <app-read-only-field label="Donantes distintas aspiradas" [value]="seguimiento.donantes_aspiradas" />
            <app-read-only-field label="Aspiraciones realizadas" [value]="seguimiento.aspiraciones_realizadas" />
          }
          @if (actual.objetivo !== 'A') {
            <app-read-only-field label="Preñeces positivas" [value]="seguimiento.preneces_positivas" />
            <app-read-only-field label="Preñeces faltantes" [value]="seguimiento.faltante" emptyText="No aplica" />
            <app-read-only-field label="Transferencias realizadas" [value]="seguimiento.transferencias_realizadas" />
            <app-read-only-field label="Diagnósticos negativos" [value]="seguimiento.diagnosticos_negativos" />
            <app-read-only-field label="Diagnósticos pendientes" [value]="seguimiento.diagnosticos_pendientes" />
          }
        </div>
      } @else {
        <p class="text-sm text-gray-500">Seguimiento no disponible.</p>
      }
    </div>
  }
      <app-form [formGroup]="editForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
          <div>
            <app-label for="cli_establecimiento_id">
              Establecimiento
            </app-label>
            <app-select id="cli_establecimiento_id" formControlName="cli_establecimiento_id" placeholder="Seleccione un establecimiento (opcional)" [options]="establecimientosOptions" />
          </div>

          <div>
            <app-label for="objetivo">
              Objetivo
            </app-label>
            <div class="flex gap-4 mt-2">
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  formControlName="aspiracion"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500"
                />
                <span class="text-sm text-gray-700 dark:text-gray-300">Aspiración</span>
              </label>
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  formControlName="transferencia"
                  class="w-4 h-4 text-blue-600 focus:ring-blue-500"
                />
                <span class="text-sm text-gray-700 dark:text-gray-300">Transferencia</span>
              </label>
            </div>
            @if (editForm.hasError('objetivoRequerido') && editForm.touched) {
              <p class="mt-1 text-sm text-error-500">Seleccione al menos un objetivo.</p>
            }
          </div>

          <div>
            <app-label for="cantidad_preneces_proyectadas">
              Cantidad de Preñeces Proyectadas
            </app-label>
            <app-input-field id="cantidad_preneces_proyectadas" type="number" min="0" formControlName="cantidad_preneces_proyectadas" />
          </div>

          <div>
            <app-label for="cantidad_donantes">
              Plantel de donantes (informativo)
            </app-label>
            <app-input-field id="cantidad_donantes" type="number" min="0" formControlName="cantidad_donantes" />
          </div>
        </div>
      </app-form>

      @if (objetivo) {
        <div class="mb-5 space-y-5">
          <h3 class="text-lg font-medium dark:text-white">Trabajos considerados</h3>
          @if (objetivo.objetivo === 'X') {
            <div>
              <app-label for="tipo-trabajo-objetivo">Actividad</app-label>
              <app-select id="tipo-trabajo-objetivo" [options]="tipoTrabajoOptions" [ngModel]="tipoTrabajo" (ngModelChange)="cambiarTipoTrabajo($event)" />
            </div>
          }
          @if (errorTrabajos) {
            <p class="text-sm text-error-500">No se pudieron cargar los trabajos.</p>
            <app-button variant="outline" size="sm" (btnClick)="cargarTrabajos()">Reintentar</app-button>
          } @else {
            <app-data-table class="min-w-0 max-w-full [&_.table-vitrotech]:overflow-x-auto [&_table]:w-full [&_table]:min-w-[720px]"
              [columns]="columnasTrabajos" [data]="trabajos" [loading]="loadingTrabajos" [clickableRows]="false"
              emptyTitle="No hay trabajos en este alcance" emptySubtitle="Se consideran solo las actividades realizadas dentro del período y que no estén anuladas.">
              <ng-template appTableCell="fecha" let-trabajo>{{ trabajo.fecha | date:'dd/MM/yyyy' }}</ng-template>
              <ng-template appTableCell="fecha_diagnostico" let-trabajo>{{ (trabajo.fecha_diagnostico | date:'dd/MM/yyyy') || '—' }}</ng-template>
              <ng-template appTableCell="animal" let-trabajo>{{ trabajo.animal || 'Sin nombre' }} @if (trabajo.animal_id) { (#{{ trabajo.animal_id }}) }</ng-template>
            </app-data-table>
            @if (!loadingTrabajos) {
              <app-pagination class="[&>div]:flex-wrap [&>div]:gap-3 [&>div]:px-0 [&>div>div]:flex-wrap [&>div>div]:gap-2"
                [currentPage]="pagina" [lastPage]="ultimaPagina" [perPage]="porPagina" [total]="totalTrabajos"
                (pageChange)="cargarTrabajos($event)" (perPageChange)="cambiarPorPagina($event)" />
            }
          }
        </div>
      }

      <app-edition-buttons *hasPermission="'clientes:edit'"
        [editable]="editable"
        [valid]="editForm.valid"
        [process]="updating"
        [hideEditButton]="true"
        (onCancelClick)="close()"
        (onGoBackClick)="close()"
        (onUpdateClick)="update()"
      />
</app-modal>
